import { render, staticRenderFns } from "./WinPointsCard.vue?vue&type=template&id=e2843a4c&"
import script from "./WinPointsCard.vue?vue&type=script&lang=js&"
export * from "./WinPointsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports